import { paths } from "../navigation/navigate";
import BubbleChartIcon from "@material-ui/icons/BubbleChart";
const pagesConfig = {
  notLogged: [
    {
      navigationId: 0,
      path: paths.login,
      name: "Login",
    },
    {
      navigationId: 0,
      path: paths.guest,
      name: "GuestHome",
      working: true,
    },
    {
      navigationId: 1,
      path: paths.forgetPassword,
      name: "EsqueceuSenha",
    },
    {
      navigationId: 3,
      path: paths.renter,
      name: "Renter",
      working: true,
    },
  ],
  logged: [
    {
      dontShow: true,
      pages: [
        {
          navigationId: 0,
          path: paths.login,
          name: "Home",
          working: true,
        },
        {
          navigationId: 0,
          path: paths.guest,
          name: "GuestHome",
          working: true,
        },
        {
          navigationId: 3,
          path: paths.renter,
          name: "Renter",
          working: true,
        },
      ],
    },
  ],
};
export default pagesConfig;
